import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class Prefix extends BaseOption {
  static userInterfaceComponent = {
    label: "Prefix",
    component: inspectorTools.SIMPLE_INPUT,
  };

  static defaultValue = "";
}
